import React from 'react';
import styles from './news.module.scss';
interface INewsImg {
  srcImg: any;
  titleImg: string;
  descript: string;
}
const NewsImg = (props: INewsImg) => {
  return (
    <>
      <div className={`${styles['imgContainer']}`}>
        <img
          src={props.srcImg}
          alt="imgNew1"
          className={'w-full lg:w-[400px] h-[400px] object-cover cursor-pointer'}
        />
        <div className={`${styles['imgContainer-blur']} w-full lg:max-w-[400px]`}>
          <div className="text-white absolute bottom-[30px] px-5">
            <h1 className="mb-3 text-[19px] font-semibold leading-6 break-words">
              {props.titleImg}
            </h1>
            <p className="text-[#848484] font-normal leading-6 break-words">{props.descript}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsImg;
